module.exports = __webpack_public_path__ + "img/logo-icad.21ef0f3d.svg";